import { useTranslation } from 'next-i18next';

import { Box, Flex, HStack, Text } from '@chakra-ui/react';

import { dateHelpers } from '@nocowanie/core';
import { IconsLinear } from '@nocowanie/icons';

import { DATE_FORMAT } from '@app/consts';

import { CheckInTimeProps } from './check-in-time.props';

export const CheckInTime = ({
    checkInDate,
    checkOutDate,
    accommodationDetails,
    displayedDateYearFormat = DATE_FORMAT.displayedDateYearFormatWithNameOfDay,
    ...props
}: CheckInTimeProps) => {
    const { t } = useTranslation('checkout');
    const displayedDateFormat = 'dd MMM.';

    return (
        <Box
            border={'1px solid'}
            borderColor={'gray.300'}
            borderRadius={'md'}
            px={4}
            py={3}
            {...props}
        >
            <HStack>
                <Text as={'span'} fontWeight={'bold'}>
                    {t('reservationDetails.date')}:
                </Text>
                <HStack align={'center'}>
                    <Text as={'span'}>
                        {dateHelpers.format(new Date(checkInDate), displayedDateFormat)}
                    </Text>
                    <IconsLinear.ArrowRight color={'secondary.500'} size={'xs'} />
                    <Text as={'span'}>
                        {dateHelpers.format(new Date(checkOutDate), displayedDateFormat)}
                    </Text>
                </HStack>
            </HStack>
            <HStack justify={'space-between'} mt={2}>
                <Flex
                    direction={{ base: 'column', md: 'row' }}
                    align={{ base: 'start', md: 'center' }}
                    gap={{ base: 0, md: 2 }}
                    width={'50%'}
                >
                    <Text as={'span'} fontSize={{ base: 'xs', md: 'md' }} fontWeight={'bold'}>
                        {t('reservationDetails.checkIn')}:
                    </Text>
                    <Text as={'span'} fontSize={{ base: 'sm', md: 'md' }}>
                        {t('reservationDetails.from')} {accommodationDetails?.checkInStart}
                    </Text>
                </Flex>
                <Flex
                    direction={{ base: 'column', md: 'row' }}
                    align={{ base: 'start', md: 'center' }}
                    gap={{ base: 0, md: 2 }}
                    width={'50%'}
                >
                    <Text as={'span'} fontSize={{ base: 'xs', md: 'md' }} fontWeight={'bold'}>
                        {t('reservationDetails.checkOut')}:
                    </Text>
                    <Text as={'span'} fontSize={{ base: 'sm', md: 'md' }}>
                        {t('reservationDetails.to')}{' '}
                        {accommodationDetails?.checkOutEnd
                            ? accommodationDetails?.checkOutEnd
                            : accommodationDetails?.checkOutStart}
                    </Text>
                </Flex>
            </HStack>
        </Box>
    );
};
